import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './ProgrammableLogicController.frontend.types'

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_delete_connector_zone_mappingsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { connector_id?: string, footprint_zone?: string, connector_zone?: string }): Promise<{ reasons?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/functions/delete_connector_zone_mappings`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

